const mediaItems = [
  {
    title: '《剑道第一仙》第 203 话',
    tag: '国漫·热血',
    views: '328万',
    desc: '苏奕持剑独闯九重天，一剑破万法，昔日废柴今朝剑道第一人！',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhwa%20style%20illustration%20with%20swordsman%20on%20mountain%20peak%2C%20dynamic%20action%20pose%2C%20warm%20golden%20sunset%20lighting%2C%20clean%20composition%2C%20vibrant%20colors%2C%20webtoon%20cover%20art%20style%2C%20cinematic%20atmosphere&width=640&height=400&seq=media-cover-01&orientation=landscape',
  },
  {
    title: '《我独自升级》第二季 第 12 话',
    tag: '韩漫·系统流',
    views: '586万',
    desc: '成振宇觉醒暗影君主之力，地下城终极BOSS战一触即发！',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20with%20dark%20fantasy%20hunter%20in%20shadow%20armor%2C%20purple%20and%20black%20color%20scheme%2C%20dramatic%20lighting%2C%20dungeon%20atmosphere%2C%20manhwa%20cover%20art%2C%20epic%20composition&width=640&height=400&seq=media-cover-02&orientation=landscape',
  },
  {
    title: '《鬼灭之刃》柱训练篇 完结',
    tag: '日漫·少年热血',
    views: '912万',
    desc: '九柱集结最终特训，炭治郎能否突破极限迎接最终决战？',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20manga%20style%20illustration%20with%20samurai%20demon%20slayer%20characters%20in%20action%2C%20traditional%20Japanese%20aesthetic%2C%20warm%20watercolor%20texture%2C%20dynamic%20composition%2C%20vibrant%20red%20and%20gold%20accents%2C%20shonen%20manga%20cover%20art&width=640&height=400&seq=media-cover-03&orientation=landscape',
  },
  {
    title: '《全职高手》番外篇 更新中',
    tag: '国漫·电竞',
    views: '456万',
    desc: '叶修重返荣耀赛场，千机伞再现江湖，荣耀之巅谁与争锋！',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20manhua%20style%20illustration%20with%20gaming%20character%20holding%20weapon%2C%20cyberpunk%20inspired%20background%2C%20blue%20and%20gold%20accents%2C%20dynamic%20action%20scene%2C%20modern%20anime%20style%2C%20clean%20composition&width=640&height=400&seq=media-cover-04&orientation=landscape',
  },
  {
    title: '《某天成为公主》第 98 话',
    tag: '韩漫·穿越',
    views: '267万',
    desc: '希娅公主的逆袭之路，宫廷权谋与浪漫交织的异世界物语！',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20fantasy%20manhwa%20style%20illustration%20with%20princess%20in%20elegant%20dress%2C%20royal%20palace%20background%2C%20soft%20pink%20and%20gold%20lighting%2C%20shojo%20webtoon%20aesthetic%2C%20romantic%20atmosphere%2C%20clean%20decorative%20composition&width=640&height=400&seq=media-cover-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精彩推荐</h2>
            <p className="text-foreground-500 text-sm mt-2">精选热门漫画，滚动阅读一话到底</p>
          </div>
          <a
            href="#ranking"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item, i) => (
            <div key={i} className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md bg-black/60 text-white text-[10px] font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
                  <span className="text-white text-[10px] flex items-center gap-1">
                    <i className="ri-play-circle-fill text-xs"></i> {item.views}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}